import { collectCss } from '../../../../../../../internal/style-injector/src/index.mjs';

var css$1 = ".EditableRow_module_row__4e3b092b{align-items:center;display:flex;gap:var(--st-spacing-2);height:calc(var(--st-line-height-sm)*var(--st-text-sm) + var(--st-spacing-8));width:100%}.EditableRow_module_input__4e3b092b{flex:1 1 auto}.EditableRow_module_actions__4e3b092b{display:flex;flex:0 0 auto;gap:var(--st-spacing)}";
collectCss(css$1);
var modules_20f268b7 = {"row":"EditableRow_module_row__4e3b092b","input":"EditableRow_module_input__4e3b092b","actions":"EditableRow_module_actions__4e3b092b"};

export { css$1 as css, modules_20f268b7 as default };
//# sourceMappingURL=EditableRow.module.css.mjs.map
